import React, { Component } from 'react';
import Parser from 'html-react-parser';
import { MenuIcon, EmailIcon, LocationIcon, PhoneIcon } from './SVGIcons';

import OffcanvasForm from './OffcanvasForm';

class App extends Component {
  state = {

  }

  componentDidMount() {

  }

  componentWillUnmount() {

  }

  constructor(props) {
    super(props);
    this.state = {
      showCallForm: false,
    };
  }

  // Метод для открытия формы заказа звонка
  openCallForm = () => {
    this.setState({ showCallForm: true });
  };

  // Метод для закрытия формы заказа звонка
  closeCallForm = () => {
    this.setState({ showCallForm: false });
  };

  // Обработчик успешной отправки
  handleFormSuccess = (message) => {
    // Закрываем Offcanvas меню
    this.props.hide();
    // Показываем сообщение об успехе
    if (this.props.onSuccess) {
      this.props.onSuccess(message);
    }
  };

  // Обработчик ошибки отправки
  handleFormError = (error) => {
    if (this.props.onError) {
      this.props.onError(error);
    }
  };

  render() {

    const { showMenu } = this.props
    const data = this.props?.data || {}
    const { showCallForm } = this.state

    return (
      <>
        <div className='w-full h-[58px] lg:h-[136px]' />
        <div className='fixed top-0 left-0 w-full bg-[#F6F7F8] lg:bg-white z-20'>
          <div className='container'>
            <div className='h-[58px] lg:h-[74px] flex items-center justify-between'>
              <div className='flex items-center gap-[16px]'>
                <a href="/">
                  <img src={data.logo} width={82} height={40} className='h-auto flex-none' />
                </a>
                <div className='hidden sm:block h-[24px] w-px bg-[#1414141A]' />
                <div className='hidden sm:block text-small text-ptblack font-light leading-[110%]'>
                  {Parser(data?.slogan || '')}
                </div>
                <div className='hidden lg:block h-[24px] w-px bg-[#1414141A]' />
                <div onClick={() => showMenu()} className='cursor-pointer bg-[#F6F7F8] duration-300 ease-in-out hover:bg-[#DBE7F3] px-[22px] h-[42px] flex-none hidden lg:flex items-center justify-center rounded-[14px] gap-[12px] text-[#001553]'>
                  <MenuIcon stroke="#001553" />
                  <div className='text-base'>Меню</div>
                </div>
                <div className='hidden lg:block h-[24px] w-px bg-[#1414141A]' />
                <a className='hidden lg:block' href={`tel:${data?.phone[0].replace(/[-()\s]/g, '')}`}>{data?.phone[0]}</a>
              </div>
              <div className='flex items-center justify-between gap-[16px]'>
                <div className='gap-[8px] hidden lg:flex items-center'>
                  <EmailIcon className='flex-none' />
                  <div className='text-ptgray text-small leading-[110%]'>
                    {data?.email?.length > 0 ? data.email.map((email, index) => (
                      <>
                        {index > 0 && <br />}
                        <a key={index} href={`mailto:${email}`}>
                          {email}
                        </a>
                      </>
                    )) : ''}
                  </div>
                </div>
                <div className='gap-[8px] hidden lg:flex items-center'>
                  <LocationIcon className='flex-none' />
                  <a href={data?.adreslink || ''} target='_blank' className='text-ptgray text-small leading-[110%]'>
                    {Parser(data?.adres || '')}
                  </a>
                </div>
                <div className='hidden lg:block h-[24px] w-px bg-[#1414141A]' />
                <a href={`tel:${data?.phone[0].replace(/[-()\s]/g, '')}`} className='cursor-pointer bg-[#BC0005] duration-300 ease-in-out hover:bg-[#930105] px-[22px] xl:px-[32px] h-[38px] xl:h-[42px] flex-none flex items-center justify-center rounded-[14px] gap-[12px] text-white'>
                  <PhoneIcon />
                  <div className='text-base'>Связаться</div>
                </a>
                <div className='lg:hidden h-[24px] w-px bg-[#1414141A]' />
                <div onClick={() => showMenu()} className='cursor-pointer bg-white px-[12px] h-[38px] xl:h-[42px] flex-none flex lg:hidden items-center justify-center rounded-[14px] gap-[12px] text-[#001553]'>
                  <MenuIcon stroke="#001553" />
                  <div className='hidden sm:block text-base'>Меню</div>
                </div>
              </div>
            </div>
            <div className='hidden lg:flex items-center justify-between h-[62px] w-full bg-[#F6F7F8] rounded-[14px] px-[10px]'>
              <div className='flex items-center gap-[16px]'>
                <div className='relative group'>
                  <div className='cursor-pointer bg-[#141414] px-[12px] h-[42px] flex-none flex items-center justify-center rounded-[14px] gap-[12px] text-white'>
                    <MenuIcon />
                    <div className='text-base'>Продукция</div>
                  </div>

                  {/* Невидимый элемент для сохранения hover при движении мышки */}
                  <div className='hidden group-hover:block absolute top-full left-0 w-full h-[8px]'></div>

                  {/* Dropdown меню */}
                  <div className='hidden group-hover:block absolute top-full left-0 mt-[8px] bg-white border border-gray-200 rounded-[14px] shadow-lg px-[12px] py-[8px] min-w-[240px] z-50'>
                    {data.catalog_menu.map((item, index) => (
                      <a key={index} href={item.url} className='block px-[12px] py-[8px] text-base text-ptblack hover:text-[#BC0005] hover:bg-gray-100 rounded-[8px] transition-colors'>
                        {item.pagetitle}
                      </a>
                    ))}
                  </div>
                </div>
                <div className='h-[24px] w-px bg-[#1414141A]' />
                <div className='flex items-center gap-[22px]'>
                  {data?.menu.map((item, index) => (
                    <a key={index} className='text-base text-ptblack' href={item.url}>{item.pagetitle}</a>
                  ))}
                </div>
              </div>
              
              {/* Измененный блок "На маркетплейсах" с выпадающим списком */}
              <div className='relative group'>
                <div className='flex items-center gap-[8px] cursor-pointer'>
                  <img src={data?.marketImage} width={42} height={26} className='flex-none h-auto' />
                  <div className='text-base text-ptblack'>На маркетплейсах</div>
                </div>
                
                {/* Невидимый элемент для сохранения hover */}
                <div className='hidden group-hover:block absolute top-full right-0 w-full h-[8px]'></div>
                
                {/* Dropdown меню маркетплейсов */}
                <div className='hidden group-hover:block absolute top-full right-0 mt-[8px] bg-white border border-gray-200 rounded-[14px] shadow-lg py-[8px] min-w-[180px] z-50'>
                  <a 
                    href={data?.market} 
                    target='_blank' 
                    className='block px-[16px] py-[8px] text-base text-ptblack hover:text-[#BC0005] hover:bg-gray-100 rounded-[8px] transition-colors whitespace-nowrap'
                  >
                    Ozon
                  </a>
                  <a 
                    href={data?.market2} 
                    target='_blank' 
                    className='block px-[16px] py-[8px] text-base text-ptblack hover:text-[#BC0005] hover:bg-gray-100 rounded-[8px] transition-colors whitespace-nowrap'
                  >
                    Wildberries
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Форма заказа звонка */}
        <OffcanvasForm
          show={showCallForm}
          hide={this.closeCallForm}
          formTitle="Связаться"
          formText="Оставьте свои контактные данные, и мы свяжемся с вами в ближайшее время."
          onSuccess={this.handleFormSuccess}
          onError={this.handleFormError}
        />
      </>
    )
  }
}

export default App;